export default __webpack_public_path__ + "static/media/Ball.9430bed0.svg";